// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9XXaH","question":"styles_question__2rLvl","inputVisibleButton":"styles_inputVisibleButton__3PyuU","note":"styles_note__1U7NQ"};